import { connect } from 'react-redux';
import DuplicateModal from './DuplicateModal';
import { duplicateACPackagedUnit } from '../../redux/ac_packaged_unit/ac_packaged_unit_actions';

const mapStateToProps = state => ({
  isDuplicating: state.ac.packagedUnit.isDuplicating,
  errorMessage: state.ac.packagedUnit.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateACPackagedUnit(id, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/duplicate/ACPackagedUnitDuplicateModal.js